import type { TextBoxColors } from 'atoms/TextBox'
import type { IMobileMenu } from './MobileMenu'

import { styled } from '@linaria/react'
import { NavTabLink } from 'atoms/NavTab'
import { TextBoxSC } from 'atoms/TextBox'
import { DropdownBody, DropdownHeaderStyled } from 'blocks/Dropdown'
import { DropdownItemTypeDivStyled } from 'blocks/Dropdown/DropdownItems'
import { DropdownItemsGroupStyled } from 'blocks/Dropdown/DropdownItemsGroup'
import { DropdownBrowseTemplate } from 'blocks/Dropdown/Templates'
import { NavGroupSC, NavGroupWithMoreSC } from 'blocks/NavGroup/NavGroup.styled'
import { COLOR, FIXED_INDENTS, MEDIA, NAVBAR_HEIGHT } from 'vars/index'

export const ToggleIconSC = styled.div`
  display: flex;
  position: relative;
  background: transparent;
  padding: var(${FIXED_INDENTS.INDENT_40});
  order: -1;
`
export const ToggleInput = styled.input``

export const MenuOverlay = styled.div``

export const MobileMenuSC = styled.div<
  Omit<IMobileMenu, 'children'> & { colorDefault?: TextBoxColors }
>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  height: 100%;
  padding-left: 0;
  touch-action: none;
  -ms-touch-action: none;

  & ${NavGroupWithMoreSC} {
    & ${NavGroupSC} {
      background: ${({ background }) =>
        background ? `var(${background})` : 'transparent'};
      flex-direction: column;
      position: absolute;
      top: ${({ height }) => (height ? `${height}px` : 'auto')};
      left: 0;
      height: 100vh;
      transform: translateX(-100%);
      transition: all 0.4s ease-in-out;
      justify-content: flex-start;

      & ${NavTabLink} {
        max-width: initial;
        width: ${({ width }) => (width ? `${width}px` : 'auto')};
        color: ${({ colorDefault }) =>
          colorDefault ? `var(${colorDefault})` : 'inherit'};
      }
    }
  }

  & ${DropdownBrowseTemplate} {
    background: ${({ background }) =>
      background ? `var(${background})` : 'transparent'};
    position: absolute;
    top: ${({ height }) => (height ? `${height}px` : 'auto')};
    left: 0;
    transform: translateX(-100%);
    transition: all 0.4s ease-in-out;

    & ${DropdownHeaderStyled} {
      display: none;
    }

    & ${DropdownBody} {
      width: 100vw;
      max-height: calc(100vh - var(${NAVBAR_HEIGHT.DEFAULT}));
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      overflow: auto;
      position: initial;

      ${MEDIA.MIN_600} {
        flex-direction: row;
      }

      & ${DropdownItemsGroupStyled} {
        width: 100%;
        display: flex;
        overflow: initial;

        ${MEDIA.MAX_599} {
          &:not(:last-child) {
            border-right-color: var(${COLOR.TRANSPARENT});
          }

          & > ${TextBoxSC}, ${DropdownItemTypeDivStyled} {
            padding-left: 16px;
          }
        }
      }
    }
  }

  & ${ToggleInput} {
    display: flex;
    position: absolute;
    width: ${({ height }) => (height ? `${height}px` : 'auto')};
    height: ${({ height }) => (height ? `${height}px` : 'auto')};
    opacity: 0;
    z-index: 2;
    cursor: pointer;
  }

  & ${MenuOverlay} {
    background: ${({ backgroundOverlay }) =>
      backgroundOverlay ? `var(${backgroundOverlay})` : 'transparent'};
    position: absolute;
    top: ${({ height }) => (height ? `${height}px` : 'auto')};
    left: 0;
    width: 100vw;
    height: 100vh;
  }

  & ${ToggleInput}:checked ~ ${NavGroupWithMoreSC} ${NavGroupSC} {
    transform: translateX(0);
    z-index: 5;
  }

  & ${ToggleInput}:checked ~ ${DropdownBrowseTemplate} {
    transform: translateX(0);
    z-index: 5;
  }
`
